import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import React from "react";
import { Box, Button, TextField, TextFieldProps } from "@mui/material";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";
import { LanguageSelect } from "../TranslatableEditor/LanguageSelect";
import { ApiTranslation, useCustomTranslationsStorage, useLanguages } from "../CustomizableTexts/CustomizableTexts";
import { useWatch } from "react-hook-form";
import _ from "lodash";

export default function FormCustomizableTextTC({
  inputProps,
  tKey,
  tDefault,
  translatableText,
  model,
  modelId,
}: {
  inputProps?: TextFieldProps;
  tKey: string;
  tDefault: string;
  formFieldProps?: any;
  translatableText: string;
  model: string;
  modelId: number;
}) {
  const { selectedLanguage, activeLanguages, changeLanguage } = useLanguages();
  const source_translations: ApiTranslation[] = useWatch({ name: "customizable_texts" });

  const { translations, dirtyTranslations, saveTranslations, loading, error, setDirtyTranslations, setTranslations } =
    useCustomTranslationsStorage({
      modelId,
      translatableTexts: [translatableText],
      source_translations,
      model,
    });

  return (
    <FormFieldTwoColumns tDefault={tDefault} tKey={tKey}>
      {translations ? (
        <Box style={{ display: "flex", width: "100%", gap: "8px", alignItems: "baseline" }}>
          <TextField
            color={"primary"}
            inputProps={{
              style: {
                backgroundColor: "rgba(100, 100, 100, 0.05)",
              },
            }}
            onChange={(event) => {
              _.set(translations, `[${selectedLanguage.value}][${translatableText}]`, event.target.value);
              setTranslations(_.cloneDeep(translations));
              setDirtyTranslations(_.concat(dirtyTranslations, translatableText));
            }}
            style={{ width: "100%" }}
            value={translations[selectedLanguage.value][translatableText]}
            {...inputProps}
          />
          <LanguageSelect
            allowedLanguages={activeLanguages}
            language={selectedLanguage.value}
            onChange={changeLanguage}
          />
          <Button
            color={"secondary"}
            disabled={dirtyTranslations.length === 0 || loading}
            onClick={() => {
              saveTranslations(translations);
            }}
            variant={"contained"}
          >
            {loading ? (
              "Saving"
            ) : (
              <TranslationWrapper tDefault={"Save"} tKey={"button.customizable-translations.save-short"} />
            )}
          </Button>
        </Box>
      ) : (
        <>loading</>
      )}
    </FormFieldTwoColumns>
  );
}
